import LogRocketProvider from "./LogRocketProvider";

export default LogRocketProvider;
